import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { compose, map, split } from 'ramda'

export const toParagraphs = compose(
  map(line => <p key={line}>{line}</p>),
  split('\n')
)

const InjectMessage = props => <FormattedMessage {...props} />

InjectMessage.propTypes = {
  id: PropTypes.string,
  description: PropTypes.string,
  defaultMessage: PropTypes.string,
  values: PropTypes.object
}

export default injectIntl(InjectMessage, {
  withRef: false
})



// WEBPACK FOOTER //
// ./util/IntlMessages.js